/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelled: {
    id: 'account.order.state.cancelled',
    defaultMessage: 'cancelled',
  },
  paid: {
    id: 'account.order.state.paid',
    defaultMessage: 'paid',
  },
  onhold: {
    id: 'account.order.state.onhold',
    defaultMessage: 'on hold',
  },
  orderstobechecked: {
    id: 'account.order.state.orderstobechecked',
    defaultMessage: 'to be checked',
  },
  open: {
    id: 'account.order.state.open',
    defaultMessage: 'open',
  },
  inprint: {
    id: 'account.order.state.inprint',
    defaultMessage: 'in print',
  },
  inproduction: {
    id: 'account.order.state.inproduction',
    defaultMessage: 'in production',
  },
  inlayout: {
    id: 'account.order.state.inlayout',
    defaultMessage: 'in layout',
  },
  readyforinspection: {
    id: 'account.order.state.readyforinspection',
    defaultMessage: 'ready for inspection',
  },
  filesrejected: {
    id: 'account.order.state.filesrejected',
    defaultMessage: 'files rejected',
  },
  waitforsupervisor: {
    id: 'account.order.state.waitforsupervisor',
    defaultMessage: 'waiting for supervisor',
  },
  inprogress: {
    id: 'account.order.state.inprogress',
    defaultMessage: 'in progress',
  },
  processing: {
    id: 'account.order.state.processing',
    defaultMessage: 'processing',
  },
  confirmed: {
    id: 'account.order.state.confirmed',
    defaultMessage: 'confirmed',
  },
  completed: {
    id: 'account.order.state.completed',
    defaultMessage: 'completed',
  },
  complete: {
    id: 'account.order.state.complete',
    defaultMessage: 'complete',
  },
  unknown: {
    id: 'account.order.state.unknown',
    defaultMessage: 'unknown',
  },
  accountTitle: {
    id: 'account.order.details.title',
    defaultMessage: 'Order details',
  },
  customerDetails: {
    id: 'account.order.orderedBy',
    defaultMessage: 'Customer details',
  },
  ideal: {
    id: 'account.order.payment.title.ideal',
    defaultMessage: 'iDEAL',
  },
  mandate: {
    id: 'account.order.payment.title.mandate',
    defaultMessage: 'Mandate',
  },
  paypal: {
    id: 'account.order.payment.title.paypal',
    defaultMessage: 'PayPal',
  },
  thumbnailAlt: {
    id: 'account.order.thumbnail.alt',
    defaultMessage: 'The alt of the upload artwrok thumbnail',
  },
  creditCard: {
    id: 'account.order.payment.title.creditcard',
    defaultMessage: 'CreditCard',
  },
  onAccount: {
    id: 'account.order.payment.title.onAccount',
    defaultMessage: 'On Account',
  },
  mc: {
    id: 'account.order.payment.title.mc',
    defaultMessage: 'Mastercard',
  },
  bcmc: {
    id: 'account.order.payment.title.bcmc',
    defaultMessage: 'BCMC',
  },
  bcmc_mobile: {
    id: 'account.order.payment.title.bcmc_mobile',
    defaultMessage: 'BCMC mobile',
  },
  cartebancaire: {
    id: 'account.order.payment.title.cartebancaire',
    defaultMessage: 'Carte Bancaire',
  },
  cartebleue: {
    id: 'account.order.payment.title.cartebleue',
    defaultMessage: 'Carte Bleue',
  },
  visa: {
    id: 'account.order.payment.title.visa',
    defaultMessage: 'Visa',
  },
  amex: {
    id: 'account.order.payment.title.amex',
    defaultMessage: 'AMEX',
  },
  afterPay: {
    id: 'account.order.payment.title.afterPay',
    defaultMessage: 'Afterpay',
  },
  orderTitle: {
    id: 'account.orders.title',
    defaultMessage: 'Order title',
  },
  AUTHORISED: {
    id: 'payment.confirmation.authorised',
    defaultMessage: 'Paid successfully!',
  },
  REFUSED: {
    id: 'payment.confirmation.refused',
    defaultMessage: "Hmm, you're payment was refused..",
  },
  CANCELLED: {
    id: 'payment.confirmation.cancelled',
    defaultMessage: 'Payment cancelled!',
  },
  PENDING: {
    id: 'payment.confirmation.pending',
    defaultMessage: 'Payment pending!',
  },
  ERROR: {
    id: 'payment.confirmation.error',
    defaultMessage: 'Oops, something went wrong processing your payment',
  },
  orderSearchPlaceholder: {
    id: 'account.order.list.search.placeholder',
    defaultMessage: 'Search for product name, order number, reference or PO number',
  },
  filterAll: {
    id: 'account.order.list.filter.all',
    defaultMessage: 'Status: All',
  },
  filterPaymentNeeded: {
    id: 'account.order.list.filter.paymentNeeded',
    defaultMessage: 'Status: Payment needed',
  },
  filterNeedsFileDelivery: {
    id: 'account.order.list.filter.needsFileDelivery',
    defaultMessage: 'Status: Waiting for artwork',
  },
  filterInProduction: {
    id: 'account.order.list.filter.inProduction',
    defaultMessage: 'Status: In production',
  },
  filterShipped: {
    id: 'account.order.list.filter.shipped',
    defaultMessage: 'Status: Shipped',
  },
  filterCancelled: {
    id: 'account.order.list.filter.cancelled',
    defaultMessage: 'Status: Cancelled',
  },
  filterDocReviewInProofing: {
    id: 'account.order.list.filter.filterDocReviewInProofing',
    defaultMessage: 'Status: DocReviewInProofing',
  },
  fileInvalid: {
    id: 'account.order.list.file.invalid',
    defaultMessage: 'File not available (expired)',
  },
  ordersError: {
    id: 'account.order.list.fetch.error',
    defaultMessage: 'Oh oh! Something wen\t wrong while fetching your orders, please refresh the page to try again..',
  },
  poNumber: {
    id: 'account.order.poNumber',
    defaultMessage: 'Po Number',
  },
  orderReference: {
    id: 'account.order.orderReference',
    defaultMessage: 'Order Reference',
  },
  orderNoValue: {
    id: 'account.order.no.value',
    defaultMessage: 'Order Value',
  },
  statusFilter: {
    id: 'account.order.statusFilter',
    defaultMessage: 'Filter Orders based on the selected status value.',
  },
});

/**
 * Extra data cannot be added to the object inside defineMessages,
 * because it is a hook to "scrape" the default messages from the component.
 * https://stackoverflow.com/questions/39811438/why-does-definemessages-from-react-intl-throw-an-error-when-passing-in-a-object
 */
messages.AUTHORISED.type = 'success';
messages.REFUSED.type = 'error';
messages.CANCELLED.type = 'error';
messages.PENDING.type = 'warning';
messages.ERROR.type = 'error';

messages.open.color = 'info';
messages.processing.color = 'primary';
messages.confirmed.color = 'info';
messages.completed.color = 'success';
messages.cancelled.color = 'dim';
messages.unknown.color = 'dim';
